/**
 * Settings for Coordinator app.
 */

const level = process.env.LEVEL || "development";
const env = {};

if (process.env.GA_TRACKING_ID) {
  env.GA_TRACKING_ID = process.env.GA_TRACKING_ID;
}

if (process.env.MIXPANEL_TOKEN) {
  env.MIXPANEL_TOKEN = process.env.MIXPANEL_TOKEN;
}

export default Object.assign({
  LEVEL: level,
}, env, {
  AUTHENTICATE_URL: `${process.env.API_URL}/api/v1/authenticate/coordinator/`,
  TIME_ZONE: process.env.TIME_ZONE,
});



/** WEBPACK FOOTER **
 ** ./src/app/config/settings.js
 **/